<template>
  <div name="stdapplinf-detail-pg16">
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['20'] }}</label>
          <div class="form-control readonly-field-color">{{ data.namcont }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['30'] }}</label>
          <div class="form-control readonly-field-color">{{ data.desrelat }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['30'] }}</label>
          <textarea class="form-control"
                    :value="data.adrpers1"
                    readonly />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['50'] }}</label>
          <div class="form-control readonly-field-color">{{ data.codpost }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['60'] }}</label>
          <div class="form-control readonly-field-color">{{ data.numtele }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['70'] }}</label>
          <div class="form-control readonly-field-color">{{ data.emailc }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['80'] }}</label>
          <div class="form-control readonly-field-color">{{ data.numfaxc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stdapplinf-detail-pg16',
  props: [ 'labels', 'data' ]
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg16.vue?e6cb8be2